<div *ngFor="let _kpis of kpis" class="hx-g">
  <div *ngFor="let kpi of _kpis" class="hx-u-1-{{ _kpis.length }}">
    <metric-one-status  [(title)]="kpi.title" origin="{{ kpi.origin }}" [(value)]="kpi.value" [(status)]="kpi.status" [(unit)]="kpi.unit"></metric-one-status>
  </div>
</div>
